import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { getRlUserPermissions, UserPermissions } from "shared/helpers/users";
import { initialUserPermissionsState } from "./userPermissionsState";

export const fetchUserPermissionsThunk = createAsyncThunk(
  "user/fetchUserPermissions",
  async ({
    userGuid,
    instCode,
    listId,
  }: {
    userGuid: string;
    instCode: string;
    listId: string;
  }) => {
    return await getRlUserPermissions(userGuid, instCode, listId);
  },
);

export const userPermissionsSlice = createSlice({
  name: "userPermissions",
  initialState: initialUserPermissionsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPermissionsThunk.pending, (state) => {
        state.isLoading = true;
        state.loadingError = undefined;
      })
      .addCase(
        fetchUserPermissionsThunk.fulfilled,
        (state, action: PayloadAction<UserPermissions>) => {
          state.data = action.payload;
          state.isLoading = undefined;
        },
      )
      .addCase(fetchUserPermissionsThunk.rejected, (state, action) => {
        state.loadingError = action.error;
        state.isLoading = undefined;
      });
  },
});

export default userPermissionsSlice.reducer;
